import { render, staticRenderFns } from "./SingleOption.vue?vue&type=template&id=77bc8274&lang=pug&"
import script from "./SingleOption.vue?vue&type=script&lang=ts&"
export * from "./SingleOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports